module.exports = __webpack_public_path__ + "static/media/IMG_5719.16f0fc70.JPG";